import { useModals } from "@/features/modals/hooks";
import { TaskTimeInfo } from "@/features/tasks/TaskTimeInfo";
import { type Task } from "@repo/api";
import { Text } from "@repo/skapa";
import { ListView, ListViewItem } from "@repo/skapa";
import { t } from "@repo/translation";

export const PrecallList = ({
  list,
  showCompleted,
}: {
  list: Task[];
  showCompleted: boolean;
}) => {
  const { pushModal } = useModals();

  if (list.length === 0) {
    return <Text>{t("prompt.no_pre_call_task")}</Text>;
  }

  const sortedList = list.sort((a, b) => {
    if (
      showCompleted &&
      a.completed?.taskCompletedDateTime &&
      b.completed?.taskCompletedDateTime
    ) {
      return (
        new Date(b.completed.taskCompletedDateTime).getTime() -
        new Date(a.completed.taskCompletedDateTime).getTime()
      );
    }
    if (a.taskDate && b.taskDate) {
      return new Date(a.taskDate).getTime() - new Date(b.taskDate).getTime();
    }
    return 0;
  });

  return (
    <ListView id="workspace-precall-list">
      {sortedList.map((item) => (
        <ListViewItem
          key={item.id}
          control="navigational"
          title={item.projectName}
          description={item.description}
          addOn={<TaskTimeInfo task={item} />}
          onClick={() => {
            pushModal({
              type: "TASK",
              task: item,
              context: "CALENDAR",
            });
          }}
        />
      ))}
    </ListView>
  );
};
